<div class="notes-container">
  <div class="notes-header">
    <div class="row">
      <div class="col-md-3">
        <div class="search-bar">
          <i class="fa fa-search"></i>
          <input
            type="text"
            placeholder="Search notes..."
            [(ngModel)]="searchText"
            (ngModelChange)="filterNotes()"
            class="search-input"
          />
        </div>
      </div>
      <div class="col-md-2">
        <select
          class="form-control filter-select"
          [(ngModel)]="filterStatus"
          (ngModelChange)="filterNotes()"
        >
          <option value="">All Statuses</option>
          <option *ngFor="let status of noteStatuses" [value]="status">{{ status }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <input
          type="date"
          class="form-control"
          [(ngModel)]="filterDateFrom"
          (ngModelChange)="filterNotes()"
          placeholder="From date"
          title="From date"
        />
      </div>
      <div class="col-md-2">
        <input
          type="date"
          class="form-control"
          [(ngModel)]="filterDateTo"
          (ngModelChange)="filterNotes()"
          placeholder="To date"
          title="To date"
        />
      </div>
      <div class="col-md-3">
        <button
          *ngIf="isEditMode"
          class="btn btn-primary"
          (click)="openAddModal()"
          title="Add Note"
        >
          <i class="fa fa-plus"></i> Add
        </button>
      </div>
    </div>
  </div>

  <div class="notes-list" *ngIf="!loadingNotes && filteredNotes.length > 0">
    <div
      class="note-card"
      *ngFor="let note of filteredNotes"
      [ngClass]="{
        'note-open': note.status === LocationNoteStatus.Open,
        'note-resolved': note.status === LocationNoteStatus.Resolved,
      }"
    >
      <!-- Status Badge -->
      <div class="note-status-badge" [ngClass]="getStatusClass(note.status)">
        {{ getStatusText(note.status) }}
      </div>

      <!-- Note Content -->
      <div class="note-body">
        <div class="note-text" [innerHTML]="getHighlightedText(note.note)"></div>
        <!-- Attached Images -->
        <div class="note-images" *ngIf="note.attachedImages && note.attachedImages.length > 0">
          <div class="image-gallery">
            <div class="image-thumbnail" *ngFor="let image of note.attachedImages; let i = index">
              <img
                [src]="getImageUrl(image.name)"
                [alt]="image.originalName"
                (click)="openImageModal(image, note.attachedImages)"
                loading="lazy"
              />
              <div class="image-caption">{{ image.originalName }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Note Footer -->
      <div class="note-footer">
        <div class="note-footer-left"></div>
        <div class="note-footer-right">
          <div class="note-meta">
            <span class="note-author" *ngIf="note.createdByUserName">{{
              note.createdByUserName
            }}</span>
            <span class="note-date">{{ note.dateCreatedUtc | date: "MM/dd/yyyy HH:mm" }}</span>
          </div>
          <div class="note-actions" *ngIf="isEditMode">
            <button class="btn-icon" (click)="openEditModal(note)">
              <i class="fa fa-pencil"></i>
            </button>
            <button class="btn-icon btn-danger" (click)="deleteNote(note)">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="loadingNotes" class="text-center" style="padding: 20px">
    <span>Loading notes...</span>
  </div>

  <div class="no-notes" *ngIf="!loadingNotes && filteredNotes.length === 0">
    <i class="fa fa-sticky-note-o"></i>
    <p>No notes found</p>
  </div>
</div>

<!-- Add Note Modal -->
<p-dialog
  [(visible)]="showAddModal"
  [header]="'Add Note'"
  [modal]="true"
  [style]="{ width: '600px' }"
  [draggable]="false"
  [resizable]="false"
  [styleClass]="'add-note-dialog'"
>
  <div class="modal-body">
    <div class="form-group">
      <label>Status <span class="text-danger">*</span></label>
      <p-dropdown
        [options]="statusOptions"
        [(ngModel)]="newNote.status"
        optionLabel="label"
        optionValue="value"
        [style]="{ width: '100%' }"
      ></p-dropdown>
    </div>

    <div class="form-group">
      <label>Note <span class="text-danger">*</span></label>
      <textarea
        class="form-control"
        [(ngModel)]="newNote.note"
        rows="6"
        placeholder="Enter note text..."
      ></textarea>
    </div>

    <div class="form-group">
      <label>Attach Images</label>
      <input
        type="file"
        #addFileInput
        (change)="onImagesSelected($event, 'add')"
        multiple
        accept="image/*"
        class="form-control"
      />
      <small class="text-muted">Select image files to attach to this note</small>

      <!-- Selected Files Preview -->
      <div class="selected-files" *ngIf="selectedFiles.length > 0">
        <div class="selected-file-preview" *ngFor="let file of selectedFiles; let i = index">
          <img [src]="getFilePreviewUrl(file)" [alt]="file.name" class="file-thumbnail" />
          <div class="file-details">
            <span class="file-name">{{ file.name }}</span>
            <span class="file-size">{{ formatFileSize(file.size) }}</span>
          </div>
          <button
            type="button"
            class="btn-remove"
            (click)="removeSelectedFile(i)"
            title="Remove image"
          >
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <p-footer>
    <div class="button-group">
      <button class="btn btn-secondary" (click)="closeAddModal()">Cancel</button>
      <button class="btn btn-primary" (click)="saveNote()">Add Note</button>
    </div>
  </p-footer>
</p-dialog>

<!-- Edit Note Modal -->
<p-dialog
  [(visible)]="showEditModal"
  [header]="'Edit Note'"
  [modal]="true"
  [style]="{ width: '600px' }"
  [draggable]="false"
  [resizable]="false"
  [styleClass]="'add-note-dialog'"
>
  <div class="modal-body" *ngIf="editingNote">
    <div class="form-group">
      <label>Status <span class="text-danger">*</span></label>
      <p-dropdown
        [options]="statusOptions"
        [(ngModel)]="editingNote.status"
        optionLabel="label"
        optionValue="value"
        [style]="{ width: '100%' }"
      ></p-dropdown>
    </div>

    <div class="form-group">
      <label>Note <span class="text-danger">*</span></label>
      <textarea
        class="form-control"
        [(ngModel)]="editingNote.note"
        rows="6"
        placeholder="Enter note text..."
      ></textarea>
    </div>

    <div class="form-group">
      <label>Attached Images</label>

      <!-- Existing Images -->
      <div
        class="selected-files"
        *ngIf="editingNote.attachedImages && editingNote.attachedImages.length > 0"
      >
        <div
          class="selected-file-preview"
          *ngFor="let image of editingNote.attachedImages; let i = index"
        >
          <img [src]="getImageUrl(image.name)" [alt]="image.originalName" class="file-thumbnail" />
          <div class="file-details">
            <span class="file-name">{{ image.originalName }}</span>
          </div>
          <button
            type="button"
            class="btn-remove"
            (click)="removeExistingImage(i)"
            title="Remove image"
          >
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>

      <!-- Add New Images -->
      <input
        type="file"
        #editFileInput
        (change)="onImagesSelected($event, 'edit')"
        multiple
        accept="image/*"
        class="form-control"
        style="margin-top: 10px"
      />
      <small class="text-muted">Select additional image files to attach</small>

      <!-- New Selected Files Preview -->
      <div class="selected-files" *ngIf="selectedFiles.length > 0">
        <div class="selected-file-preview" *ngFor="let file of selectedFiles; let i = index">
          <img [src]="getFilePreviewUrl(file)" [alt]="file.name" class="file-thumbnail" />
          <div class="file-details">
            <span class="file-name">{{ file.name }}</span>
            <span class="file-size">{{ formatFileSize(file.size) }}</span>
          </div>
          <button
            type="button"
            class="btn-remove"
            (click)="removeSelectedFile(i)"
            title="Remove image"
          >
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <p-footer>
    <div class="button-group">
      <button class="btn btn-secondary" (click)="closeEditModal()">Cancel</button>
      <button class="btn btn-primary" (click)="updateNote()">Update Note</button>
    </div>
  </p-footer>
</p-dialog>

<!-- Image Viewer Modal -->
<p-dialog
  [(visible)]="showImageModal"
  [header]="'Image Viewer'"
  [modal]="true"
  [style]="{ width: '90vw', height: '90vh' }"
  [draggable]="false"
  [resizable]="true"
  [styleClass]="'image-viewer-dialog'"
>
  <div
    class="image-viewer-content"
    *ngIf="
      currentImageGallery &&
      currentImageGallery.length > 0 &&
      currentImageIndex >= 0 &&
      currentImageIndex < currentImageGallery.length
    "
  >
    <div class="image-navigation" *ngIf="currentImageGallery.length > 1">
      <button
        class="nav-btn prev-btn"
        (click)="previousImage()"
        [disabled]="currentImageIndex === 0"
      >
        <i class="fa fa-chevron-left"></i>
      </button>

      <span class="image-counter">
        {{ currentImageIndex + 1 }} of {{ currentImageGallery.length }}
      </span>

      <button
        class="nav-btn next-btn"
        (click)="nextImage()"
        [disabled]="currentImageIndex === currentImageGallery.length - 1"
      >
        <i class="fa fa-chevron-right"></i>
      </button>
    </div>

    <div class="image-container">
      <img
        [src]="getImageUrl(currentImageGallery[currentImageIndex].name)"
        [alt]="currentImageGallery[currentImageIndex].originalName"
        class="full-image"
      />
    </div>

    <div class="image-info">
      <h5>{{ currentImageGallery[currentImageIndex].originalName }}</h5>
    </div>
  </div>

  <p-footer>
    <button class="btn btn-secondary" (click)="closeImageModal()">Close</button>
  </p-footer>
</p-dialog>
